import { useCallback, useEffect, useMemo, useState } from 'react';
import { loadEmbeddedScript } from '../util';

const useInjectScript = ({
  id,
  src,
  keepOnUmount = false,
  onError = () => { },
}) => {
  const [isLoaded, setLoaded] = useState(false);
  const scriptSrc = useMemo(() => (src), [src]);
  const scriptId = useMemo(() => (id), [id]);
  const scriptAsync = true;
  const scriptDefer = true;

  const onLoad = useCallback(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    loadEmbeddedScript({
      onErrorCallback: onError,
      onLoadCallback: onLoad,
      scriptAsync,
      scriptDefer,
      scriptId,
      scriptSrc,
    });

    return () => {
      if (!keepOnUmount) {
        document.getElementById(scriptId).remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptAsync, scriptDefer, scriptId, scriptSrc]);

  return isLoaded;
};

export { useInjectScript };
